<template>
    <input-field v-model="fvalue" :label="label" :prepend-inner-icon="prependIcon" @input="onInput"
                 :rules="[this.doValidation]" validate-on-blur :counter="counter"></input-field>
</template>

<script>
    import InputField from "./InputField";
    import validations from "./validations";

    export default {
        name: "UsernameField",
        components: {InputField},
        data() {
            return {
                fvalue: undefined,
                type: 'email'
            }
        },
        computed: {
            prependIcon() {
                if (this.type == 'email') {
                    return 'fa-envelope';
                }
                return 'fa-id-card'
            },
            label() {
                if (this.type == 'email') {
                    return 'Vaš email naslov';
                }
                return 'Številka TK kartice'
            },
            counter() {
                if (this.type == 'email'){
                    return undefined;
                }
                return 13;
            }
        },
        methods: {
            onInput() {
                if (this.fvalue && this.fvalue.startsWith('2939')) {
                    this.type = 'tk_team';
                } else {
                    this.type = 'email';
                }
                this.$emit('input', this.fvalue);
            },
            doValidation(value) {
                if (this.type == 'email') {
                    return validations.checkEmailAll(value);
                } else if (this.type == 'tk_team') {
                    return validations.checkTusTeamCard[0](value);
                }
                return 'Neveljaven vnos.'
            }
        }
    }
</script>

<style scoped>

</style>